export default __webpack_public_path__ + "2048fea565b90eb863df9342d8542d5c.svg";